import { api } from '../../api';
import { useMutation, UseMutationResult } from 'react-query';
import queryClient from '../../query-client';
import { AxiosError } from 'axios';
import { useFirmContext } from '../../providers/FirmProvider';

export type VerifyPaymentMethodRequest = {
    paymentMethodId: string;
};

async function verifyPaymentMethod(req: VerifyPaymentMethodRequest, firmId: string): Promise<void> {
    const { data } = await api.post(`/firms/${firmId}/subscription/v2/payment-methods/${req.paymentMethodId}/verify`);
    return data;
}

export function useVerifyPaymentMethod(): UseMutationResult<void, AxiosError, VerifyPaymentMethodRequest, unknown> {
    const { id } = useFirmContext();
    return useMutation((req) => verifyPaymentMethod(req, id), {
        onSettled: () => {
            queryClient.invalidateQueries(['payment-methods']);
        },
    });
}
